/*
 * @Author: liyu
 * @Date: 2022-04-25 19:52:59
 * @LastEditTime: 2022-05-19 10:21:29
 * @Description: file content
 * @FilePath: /sensors-www/src/components/SectionSwiperMobile/index.tsx
 */
import React, { ReactNode, useRef } from 'react'
import classnames from 'classnames'
import ScanCodeEntertainmentButton from 'components/Entertainment/ScanCodeEntertainmentButton'

import SwiperCore, { Pagination, Scrollbar, A11y, Autoplay, Navigation, Virtual, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import * as styles from './index.module.less'

import 'swiper/swiper.min.css'
import 'swiper/components/scrollbar/scrollbar.min.css'
import 'swiper/components/pagination/pagination.min.css'
SwiperCore.use([Pagination, Scrollbar, A11y, Autoplay, Navigation, Virtual, EffectFade])

interface SectionSwiperMobileProps {
  className?: string
  dataSource: any[]
  qrcodeButtonText?: string
  qrcodeUrl?: string
  qrcodeDesc?: string
  slotButton?: ReactNode
}
const SectionSwiperMobile: React.FC<SectionSwiperMobileProps> = ({
  className,
  dataSource,
  qrcodeButtonText = '扫码获取方案资料',
  qrcodeUrl,
  qrcodeDesc,
  slotButton,
}) => {
  return (
    <div className={classnames(styles.sectionSwiper, className)}>
      <Swiper
        direction={'horizontal'} //切换方向
        autoplay={{
          delay: 6000,
        }}
        speed={800}
        effect={'fade'} //切换效果 淡入淡出
        allowTouchMove={true} //允许触摸滑动
        scrollbar={true}
      >
        {dataSource?.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div>
                <img src={item.imgUrl} />
              </div>
              <div className="swiper-title">{item?.dataTitle}</div>
              {item?.dataDesc && (
                <div className="swiper-desc">{item?.dataDesc}</div>
              )}
              <ul className="swiper-content">
                {item?.descList?.map((desc) => (
                  <li key={desc}>{desc}</li>
                ))}
              </ul>
            </SwiperSlide>
          )
        })}
      </Swiper>
      <div className="swiper-btn">
        {slotButton ? (
          slotButton
        ) : (
          <ScanCodeEntertainmentButton buttonText={qrcodeButtonText} qrcode={qrcodeUrl} imgBottomText={qrcodeDesc} />
        )}
      </div>
    </div>
  )
}

export default SectionSwiperMobile
